import api from '@/lib/axios';
import {
    CustomerEquipmentTypeCatalogResponse,
    CustomerEquipmentTypeSearchRequest,
    CustomerEquipmentTypeResponse,
    CustomerEquipmentTypeAvailabilityRequest,
    CustomerEquipmentTypeAvailabilityResponse
} from '@/types';

export interface AvailableLocationInfo {
    locationId: string;
    locationName: string;
    city?: string;
    state?: string;
    country?: string;
    availableQuantity: number;
    isAvailable: boolean;
}

export interface AvailableLocationsResponse {
    equipmentTypeId: string;
    equipmentTypeName: string;
    locations: AvailableLocationInfo[];
}

export const getProducts = async (params: CustomerEquipmentTypeSearchRequest): Promise<CustomerEquipmentTypeCatalogResponse> => {
    const response = await api.get<CustomerEquipmentTypeCatalogResponse>('/customer/equipment-types', {
        params: {
            ...params,
            includeSubtypes: false,
        },
    });
    return response.data;
};

export const getProduct = async (
    id: string,
    locationId?: string,
    startDate?: string,
    endDate?: string
): Promise<CustomerEquipmentTypeResponse> => {
    const response = await api.get<CustomerEquipmentTypeResponse>(`/customer/equipment-types/${id}`, {
        params: {
            ...(locationId ? { locationId } : {}),
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
        },
    });
    return response.data;
};

export const getProductBySlug = async (
    slug: string,
    locationId?: string,
    startDate?: string,
    endDate?: string
): Promise<CustomerEquipmentTypeResponse> => {
    const response = await api.get<CustomerEquipmentTypeResponse>(`/customer/equipment-types/by-slug/${slug}`, {
        params: {
            ...(locationId ? { locationId } : {}),
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
        },
    });
    return response.data;
};

export const checkAvailability = async (
  id: string,
  data: CustomerEquipmentTypeAvailabilityRequest
): Promise<CustomerEquipmentTypeAvailabilityResponse> => {
  const response = await api.post<CustomerEquipmentTypeAvailabilityResponse>(
    `/customer/equipment-types/${id}/check-availability`,
        {
            ...data,
            includeSubtypes: false,
        }
  );
  return response.data;
};

export const getAvailableLocations = async (
    equipmentTypeId: string,
    startDate?: string,
    endDate?: string,
    quantity: number = 1
): Promise<AvailableLocationsResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (quantity > 1) params.append('quantity', quantity.toString());
    params.append('includeSubtypes', 'false');

    const queryString = params.toString();
    const url = `/customer/equipment-types/${equipmentTypeId}/available-locations${queryString ? `?${queryString}` : ''}`;
    const response = await api.get<AvailableLocationsResponse>(url);
    return response.data;
};

export const getRelatedProducts = async (
    equipmentTypeId: string,
    locationId?: string,
    take: number = 8
): Promise<CustomerEquipmentTypeResponse[]> => {
    const response = await api.get<CustomerEquipmentTypeResponse[]>(
        `/customer/equipment-types/${equipmentTypeId}/related`,
        {
            params: { locationId, take },
        }
    );
    return response.data;
};
